import { useQuery } from 'react-query';
import axios from 'axios';

export function useCollections({ includeInactive = false } = {}) {
  return useQuery(
    ['collections', includeInactive],
    async () => {
      const params = includeInactive ? { include_inactive: 1 } : {};
      const response = await axios.get('/api/collections', { params });
      return response.data.items || [];
    },
    { staleTime: 60 * 1000 }
  );
}
